export default __webpack_public_path__ + "static/media/employee.df03537d.png";